// src/utils/svgManager.js
class SvgManager {
  constructor() {
    this.importedSvgs = new Set();
  }

  // 导入所有 SVG 文件
  importAllSvgs() {
    const req = require.context('@/assets/svgs', true, /\.svg$/);

    req.keys().forEach(key => {
      if (!this.importedSvgs.has(key)) {
        try {
          req(key);
          this.importedSvgs.add(key);
          console.log(`Imported SVG: ${key}`);
        } catch (error) {
          console.warn(`Failed to import SVG: ${key}`, error);
        }
      }
    });
  }

  // 获取所有已导入的 SVG keys
  getSvgKeys() {
    const req = require.context('@/assets/svgs', true, /\.svg$/);
    return req.keys();
  }
}

export default new SvgManager();